import { ILocalizable } from "infrastructure/localization";
import { INotification } from "infrastructure/notification";

import { ITenant, IAccount } from "../models";

export interface ISecurityRole {
  roleId: string;
  roleName: string;
  membersNumber: number;
  tenant: ITenant;
  permissions: ISecurityRolePermission[];
}

export interface ISecurityRolesFilter {
  tenant?: ITenant;
  account?: IAccount;
}

export interface ISecurityRolesState {
  isLoading: boolean;
  notifications: INotification[];
  filter?: ISecurityRolesFilter;
  data?: ISecurityRole[];
  selectedRole?: ISecurityRole;
}

export interface ISecurityRolePermission {
  name: ILocalizable;
}

export const getInitialSecurityRolesState = (): ISecurityRolesState => ({
  isLoading: false,
  data: undefined,
  notifications: [],
  selectedRole: undefined
});
